import { render, staticRenderFns } from "./CaseMergeModal.vue?vue&type=template&id=11d9595c&scoped=true&"
import script from "./CaseMergeModal.vue?vue&type=script&lang=ts&"
export * from "./CaseMergeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d9595c",
  null
  
)

export default component.exports